/* @flow */

import React from 'react';

import { css } from 'glamor';

import { ZINDEX_NAVIGATION } from 'depop/styles/zIndex';

class Fixit extends React.Component {
  props: {
    children: (isFixed: boolean) => React.Element<*>,
  };

  state: {
    scrollY: number,
  };

  constructor(props) {
    super(props);
    this.state = { scrollY: 0 };
  }

  _handleScroll = () => {
    window.requestAnimationFrame(() => {
      this.setState({ scrollY: window.scrollY });
    });
  };

  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll);
    this._handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  render() {
    const { children } = this.props;
    const { scrollY } = this.state;

    const originalStyles = css({
      visibility: 'hidden',
      zIndex: -1,
      position: 'relative',
    });

    const isFixed = scrollY > 0;

    const styles = css({
      position: 'fixed',
      zIndex: ZINDEX_NAVIGATION,
      top: 0,
      left: 0,
      right: 0,
    });

    return (
      <div ref={el => (this._el = el)}>
        <div aria-hidden {...originalStyles}>{children(false, 0)}</div>
        <div {...styles}>{children(isFixed)}</div>
      </div>
    );
  }
}

export default Fixit;



// WEBPACK FOOTER //
// ../src/client/components/Fixit.js